import { Routes, UrlSegment } from '@angular/router';
import { HomeComponent } from './features/public-pages/components/home/home.component';
import { QuizComponent } from './features/public-pages/components/quiz/quiz.component';
import { authGuard } from './core/guards/auth.guard';
import { nonAuthGuard } from './core/guards/non-auth.guard';
import { isSupportedLanguage } from './core/services/translation.service';

function languagePrefixMatcher(segments: UrlSegment[]): { consumed: UrlSegment[], posParams: { [key: string]: UrlSegment } } | null {
  const langSegment = segments[0]?.path;
  if (isSupportedLanguage(langSegment)) {
    return {
      consumed: [segments[0]],
      posParams: { lang: segments[0] }
    };
  }
  return null; // won't match, fallback route or other route takes over
}

// Define routes without language prefix
const baseRoutes: Routes = [
  // Public routes
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'quizzes',
    loadComponent: () => import('./features/playarea/components/games-list/games-list.component')
      .then(m => m.GamesListComponent)
  },
  {
    path: 'quizzes/:searchParam/:searchValue',
    loadComponent: () => import('./features/playarea/components/games-list/games-list.component')
      .then(m => m.GamesListComponent)
  },
  {
    path: 'quiz/:slug',
    component: QuizComponent
  },
  {
    path: 'about-us',
    loadComponent: () => import('./features/public-pages/components/about/about.component')
      .then(m => m.AboutComponent)
  },
  {
    path: 'contact-us',
    loadComponent: () => import('./features/public-pages/components/contact-us/contact-us.component')
      .then(m => m.ContactUsComponent)
  },
  {
    path: 'features',
    loadComponent: () => import('./features/public-pages/components/features/features.component')
      .then(m => m.FeaturesComponent)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./features/public-pages/components/privacy-policy/privacy-policy.component')
      .then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'terms-and-conditions',
    loadComponent: () => import('./features/public-pages/components/terms-and-conditions/terms-and-conditions.component')
      .then(m => m.TermsAndConditionsComponent)
  },
  {
    path: 'news',
    loadComponent: () => import('./features/public-pages/components/news/news.component')
      .then(m => m.NewsComponent)
  },
  {
    path: 'roadmap',
    loadComponent: () => import('./features/public-pages/components/roadmap/roadmap.component')
      .then(m => m.RoadmapComponent)
  },
  {
    path: 'verify-email',
    loadComponent: () => import('./features/public-pages/components/verify-email/verify-email.component')
      .then(m => m.VerifyEmailComponent)
  },
  {
    path: 'auth',
    canActivate: [nonAuthGuard],
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES)
  },

  // Protected routes
  {
    path: 'playarea',
    canActivate: [authGuard],
    loadChildren: () => import('./features/playarea/components/playarea-layout/playarea.routes').then(m => m.PLAYAREA_ROUTES),
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadChildren: () => import('./features/profile/profile.routes')
      .then(m => m.PROFILE_ROUTES)
  }
];

// Create the main routes array with both prefixed and non-prefixed routes
export const routes: Routes = [
  // Non-prefixed routes (default language - English)
  ...baseRoutes,

  // Language-prefixed routes
  {
    // matcher: languagePrefixMatcher,
    path: ':lang',
    children: baseRoutes
  },

  // Fallback route - must be last
  {
    path: '**',
    redirectTo: ''
  }
];
